import type { StarId } from './domain.js';

export interface StarRegistryEntry {
  id: StarId;
  zhTW: string;
  family: 'major' | 'assistant' | 'special';
}

/**
 * Stable project IDs. Display labels may change with i18n; rules must use IDs.
 */
export const STAR_REGISTRY = Object.freeze([
  { id: 'ziwei', zhTW: '紫微', family: 'major' },
  { id: 'tianji', zhTW: '天機', family: 'major' },
  { id: 'taiyang', zhTW: '太陽', family: 'major' },
  { id: 'wuqu', zhTW: '武曲', family: 'major' },
  { id: 'tiantong', zhTW: '天同', family: 'major' },
  { id: 'lianzhen', zhTW: '廉貞', family: 'major' },
  { id: 'tianfu', zhTW: '天府', family: 'major' },
  { id: 'taiyin', zhTW: '太陰', family: 'major' },
  { id: 'tanlang', zhTW: '貪狼', family: 'major' },
  { id: 'jumen', zhTW: '巨門', family: 'major' },
  { id: 'tianxiang', zhTW: '天相', family: 'major' },
  { id: 'tianliang', zhTW: '天梁', family: 'major' },
  { id: 'qisha', zhTW: '七殺', family: 'major' },
  { id: 'pojun', zhTW: '破軍', family: 'major' },
  { id: 'zuofu', zhTW: '左輔', family: 'assistant' },
  { id: 'youbi', zhTW: '右弼', family: 'assistant' },
  { id: 'wenchang', zhTW: '文昌', family: 'assistant' },
  { id: 'wenqu', zhTW: '文曲', family: 'assistant' },
  { id: 'tiankui', zhTW: '天魁', family: 'assistant' },
  { id: 'tianyue', zhTW: '天鉞', family: 'assistant' },
  { id: 'lucun', zhTW: '祿存', family: 'special' },
  { id: 'tianma', zhTW: '天馬', family: 'special' },
  { id: 'qingyang', zhTW: '擎羊', family: 'special' },
  { id: 'tuoluo', zhTW: '陀羅', family: 'special' },
  { id: 'huoxing', zhTW: '火星', family: 'special' },
  { id: 'lingxing', zhTW: '鈴星', family: 'special' },
  { id: 'dikong', zhTW: '地空', family: 'special' },
  { id: 'dijie', zhTW: '地劫', family: 'special' },
] as const satisfies readonly StarRegistryEntry[]);

const BY_LABEL: ReadonlyMap<string, StarId> = new Map<string, StarId>(
  STAR_REGISTRY.map((entry) => [entry.zhTW, entry.id] as [string, StarId]),
);
const BY_ID: ReadonlyMap<StarId, StarRegistryEntry> = new Map<StarId, StarRegistryEntry>(
  STAR_REGISTRY.map((entry) => [entry.id, entry] as [StarId, StarRegistryEntry]),
);

export function starIdFromZhTW(label: string): StarId | undefined {
  return BY_LABEL.get(label);
}

export function starLabelZhTW(id: StarId): string | undefined {
  return BY_ID.get(id)?.zhTW;
}

export function stableStarIdFromZhTW(label: string): StarId {
  const normalized = label.trim();
  const registered = BY_LABEL.get(normalized);
  if (registered) return registered;
  const encoded = [...normalized].map((char) => char.codePointAt(0)?.toString(16) ?? '0').join('-');
  return `iztro-label-${encoded}`;
}
